import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Play } from "lucide-react";
import { api } from "../lib/api";
import { usePlayer } from "../context/PlayerContext";
import { useT } from "../lib/i18n";
import { MixCard } from "../components/MixCard";
import { SectionTitle } from "../components/Reveal";

// kind: "new" | "popular" | "genre"
export default function Browse({ kind }) {
  const { genre } = useParams();
  const { withOverrides, playMix } = usePlayer();
  const { t } = useT();
  const [mixes, setMixes] = useState(null);
  const name = genre ? decodeURIComponent(genre) : "";

  useEffect(() => {
    setMixes(null);
    const params = kind === "popular" ? { sort: "plays" } : kind === "genre" ? { genre: name } : { sort: "newest" };
    api.get("/mixes", { params }).then((r) => setMixes(Array.isArray(r.data) ? r.data : [])).catch(() => setMixes([]));
  }, [kind, name]);

  useEffect(() => { window.scrollTo(0, 0); }, [kind, name]);

  const list = (mixes || []).map(withOverrides);
  const title = kind === "genre" ? name : t(`browse.${kind}`);

  return (
    <main data-testid={`browse-page-${kind}`} className="max-w-[1500px] mx-auto px-4 lg:px-10 pt-32 pb-24">
      <SectionTitle index={kind === "genre" ? t("menu.genres") : "DJ T-REX"} kicker={t(`browse.${kind}.kicker`)} title={<span data-testid="browse-title">{title}<span className="text-[#1FD1FF]">.</span></span>}>
        {list.length > 0 && (
          <button data-testid="browse-play-all-button" onClick={() => playMix(list[0], list)}
            className="flex items-center gap-3 pl-2 pr-6 py-2 bg-[#1FD1FF] text-black font-mono text-sm uppercase tracking-widest hover:bg-white transition-colors">
            <span className="w-10 h-10 bg-black text-[#1FD1FF] grid place-items-center"><Play className="w-4 h-4 fill-current" /></span>{t("favs.playAll")}
          </button>
        )}
      </SectionTitle>
      {mixes && list.length === 0 && (
        <div data-testid="browse-empty" className="py-20 text-center border border-dashed border-white/15">
          <p className="text-[#A8B3C4] mb-6 max-w-sm mx-auto">{t("browse.empty")}</p>
          <Link to="/generos" data-testid="browse-genres-link" className="inline-block px-6 py-3 border border-[#1FD1FF] text-[#1FD1FF] font-mono text-sm uppercase tracking-widest hover:bg-[#1FD1FF] hover:text-black transition-colors">{t("menu.genres")}</Link>
        </div>
      )}
      {list.length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {list.map((m, i) => <MixCard key={m.id} mix={m} idx={i + 1} list={list} />)}
        </div>
      )}
    </main>
  );
}
